import { Trans } from "@lingui/react/macro"
import React from "react"

import Paragraph from "../../../../design-system/paragraph"
import { TREMENDOUS_DEVELOPER_DOCS } from "../../../../utils/urls"
import NewsletterCta from "../../../newsletter-cta"
import CategoryHeader from "../category-header"
import CategoryList from "../category-list"
import FooterLink from "../footer-link"
import LogoSection from "../logo-section"
import * as styles from "./index.module.scss"

const FooterMainSection = () => {
  return (
    <div className={styles.footerTop}>
      <div className={styles.wrapper}>
        <LogoSection />
        <div className={styles.categories}>
          <CategoryList>
            <CategoryHeader text={<Trans>roles</Trans>} />
            <FooterLink
              text={<Trans>Research</Trans>}
              to="/solutions/research-incentives"
            />
            <FooterLink
              text={<Trans>Marketing</Trans>}
              to="/solutions/marketing-incentives"
            />
            <FooterLink
              text={<Trans>Sales</Trans>}
              to="/solutions/sales-incentives"
            />
            <FooterLink
              text={<Trans>HR</Trans>}
              to="/solutions/employee-incentives"
            />
          </CategoryList>

          <CategoryList>
            <CategoryHeader text={<Trans>industries</Trans>} />
            <FooterLink
              text={<Trans>Nonprofits</Trans>}
              to="/solutions/nonprofits"
            />
            <FooterLink
              text={<Trans>Legal disbursements</Trans>}
              to="/solutions/legal-disbursements"
            />
          </CategoryList>

          <CategoryList>
            <CategoryHeader text={<Trans>developers</Trans>} />
            <FooterLink text={<Trans>API</Trans>} to="/gift-card-api" />
            <FooterLink
              text={<Trans>Documentation</Trans>}
              to={TREMENDOUS_DEVELOPER_DOCS}
            />
            <FooterLink
              text={<Trans>Status</Trans>}
              to="https://status.tremendous.com/?__hstc=17958374.f07cec01d1b8bb061fef5a6b2c11fe06.1627321806297.1649111617340.1649690885968.86&amp;__hssc=17958374.9.1649690885968&amp;__hsfp=1978775679"
            />
            <FooterLink
              text={<Trans>Vulnerability disclosure</Trans>}
              to="/vulnerability-disclosure"
            />
          </CategoryList>

          <CategoryList>
            <CategoryHeader text={<Trans>catalog</Trans>} />
            <FooterLink text={<Trans>Full Catalog</Trans>} to="/catalog" />
            <FooterLink
              text={<Trans>Prepaid cards</Trans>}
              to="/products/visa-cards"
            />
            <FooterLink
              text={<Trans>Gift cards</Trans>}
              to="/products/gift-cards"
            />
            <FooterLink
              text={<Trans>Monetary payouts</Trans>}
              to="/products/bulk-payouts"
            />
            <FooterLink
              text={<Trans>Charity</Trans>}
              to="/products/charity-gift-cards"
            />
            <FooterLink
              text={<Trans>Amazon.com gift cards</Trans>}
              to="/catalog/amazon-gift-cards"
            />
          </CategoryList>

          <CategoryList>
            <CategoryHeader text={<Trans>integrations</Trans>} />
            <FooterLink
              text={<Trans>Integration partners</Trans>}
              to="/integrations"
            />
            <FooterLink
              text={<Trans>Zapier</Trans>}
              to="/integrations/zapier"
            />
          </CategoryList>

          <CategoryList>
            <CategoryHeader text={<Trans>resources</Trans>} />
            <FooterLink text={<Trans>Pricing</Trans>} to="/pricing" />
            <FooterLink
              text={<Trans>Help center</Trans>}
              to="https://help.tremendous.com/en/articles"
            />
            <FooterLink
              text={<Trans>Client stories</Trans>}
              to="/case-studies"
            />
            <FooterLink
              text={<Trans>Guides, articles, and podcast</Trans>}
              to="/blog"
            />
            <FooterLink
              text={<Trans>Compare to Tango Card</Trans>}
              to="/compare/tango-card"
            />
            <FooterLink
              text={<Trans>Compare to BHN Rewards</Trans>}
              to="/compare/blackhawk-network"
            />
          </CategoryList>

          <CategoryList>
            <CategoryHeader text={<Trans>company</Trans>} />
            <FooterLink text={<Trans>About</Trans>} to="/about" />
            <FooterLink text={<Trans>Careers</Trans>} to="/careers" />
            <FooterLink text={<Trans>Newsroom</Trans>} to="/newsroom" />
            <FooterLink text={<Trans>History</Trans>} to="/company-history" />
            <FooterLink
              text={<Trans>VC-free</Trans>}
              to="/fundraising-history"
            />
          </CategoryList>
        </div>
        <div className={styles.subscriptionContainer}>
          <NewsletterCta variant="footer" />
        </div>
        <div className={styles.footnoteContainer}>
          <Paragraph variant="3" className={styles.footnote}>
            <Trans>
              Visa is a registered trademark of Visa U.S.A. Inc. All other
              trademarks and service marks belong to their respective owners.
            </Trans>
          </Paragraph>
        </div>
      </div>
    </div>
  )
}

export default FooterMainSection
